(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sherb-product"] && !Shopify.designMode) return;
  try {
    function initializeSherbProducts(scope) {
  scope.querySelectorAll('[data-sherb-product]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(root.querySelector('[data-sp-variants]').textContent);
    const gallery = root.querySelector('.sp-gallery');
    const rail = root.querySelector('.sp-thumbnails');
    let allPhotos = [...gallery.children];
    let allThumbs = [...rail.querySelectorAll('[data-sp-thumbnail]')];
    let photos = allPhotos;
    let thumbs = allThumbs;
    const previous = root.querySelector('[data-sp-prev]');
    const next = root.querySelector('[data-sp-next]');
    const count = root.querySelector('[data-sp-count]');
    let photoIndex = 0;
    const optionFields = [...root.querySelectorAll('[data-sp-option]')];
    const sizeOrder = ['XXS','XS','S','M','L','XL','2XL','XXL','3XL','XXXL'];
    optionFields.forEach(field => {
      if (field.querySelector('legend').textContent.trim().toLowerCase() !== 'size') return;
      const values = field.querySelector('.sp-values');
      [...values.children].sort((a,b) => {
        const rank = el => { const i = sizeOrder.indexOf(el.querySelector('input').value.toUpperCase()); return i < 0 ? 99 : i; };
        return rank(a)-rank(b);
      }).forEach(label => values.append(label));
    });

    function updatePhotos() {
      photoIndex = Math.max(0, Math.min(photos.length - 1, Math.round(gallery.scrollLeft / gallery.clientWidth)));
      thumbs.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(index === photoIndex)));
      if (previous) previous.disabled = photoIndex === 0;
      if (next) next.disabled = photoIndex === photos.length - 1;
      if (count) count.textContent = count.dataset.pattern.replace('[current]', photoIndex + 1).replace('[total]', photos.length);
    }

    function showPhoto(index) {
      gallery.scrollTo({ left: Math.max(0, Math.min(photos.length - 1, index)) * gallery.clientWidth, behavior: 'instant' });
      updatePhotos();
      const thumb = thumbs[photoIndex];
      if (thumb) {
        if (getComputedStyle(rail).flexDirection === 'row') rail.scrollLeft = thumb.offsetLeft - rail.offsetLeft;
        else rail.scrollTop = thumb.offsetTop - rail.offsetTop;
      }
    }

    allThumbs.forEach(thumb => thumb.addEventListener('click', () => {
      const index = thumbs.indexOf(thumb);
      if (index >= 0) showPhoto(index);
    }));
    previous?.addEventListener('click', () => showPhoto(photoIndex - 1));
    next?.addEventListener('click', () => showPhoto(photoIndex + 1));
    gallery.addEventListener('scroll', updatePhotos, { passive: true });
    gallery.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      showPhoto(event.key === 'Home' ? 0 : event.key === 'End' ? photos.length - 1 : photoIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    new ResizeObserver(() => showPhoto(photoIndex)).observe(gallery);
    updatePhotos();

    function updateVariant(changeUrl, changedField) {
      let choices = optionFields.map(field => field.querySelector('input:checked')?.value);
      let variant = choices.length ? variants.find(item => item.options.every((option, index) => option === choices[index])) : variants[0];
      if (!variant && changedField?.querySelector('legend').textContent.trim().toLowerCase() === 'color') {
        const colorIndex = Number(changedField.dataset.spOption);
        const matches = variants.filter(item => item.options[colorIndex] === choices[colorIndex]);
        variant = matches.find(item => item.available) || matches[0];
        if (variant) {
          optionFields.forEach((field,index) => field.querySelectorAll('input').forEach(input => input.checked = input.value === variant.options[index]));
          choices = variant.options;
        }
      }
      optionFields.forEach((field,index) => {
        if (field.querySelector('legend').textContent.trim().toLowerCase() !== 'size') return;
        field.querySelectorAll('input').forEach(input => {
          const matching = variants.find(item => item.options.every((value,i) => value === (i === index ? input.value : choices[i])));
          input.disabled = !matching;
          input.parentElement.classList.toggle('sp-sold-option', !!matching && !matching.available);
          input.setAttribute('aria-label', input.value + (!matching ? ': '+root.dataset.notOffered : !matching.available ? ': '+root.dataset.stockSold : ''));
        });
      });
      const sku = root.querySelector('[data-sp-sku]');
      const status = root.querySelector('[data-sp-selection-status]');
      const buy = root.querySelector('[data-sp-buy]');
      const input = root.querySelector('[data-sp-variant]');
      if (sku) sku.textContent = variant?.sku || '';
      status.textContent = variant ? (variant.available ? '' : root.dataset.stockSold) : status.dataset.unavailable;
      if (input) input.value = variant?.id || '';
      if (buy) {
        buy.disabled = !variant?.available || !variant?.priced;
        buy.textContent = buy.disabled ? buy.dataset.sold : buy.dataset.available;
      }
      const priceLabel = root.querySelector('[data-sp-price]');
      if (priceLabel) priceLabel.textContent = variant?.priced ? variant.price : priceLabel.dataset.pendingPrice;
      if (variant) {
        root.querySelectorAll('[data-sp-title]').forEach(element => element.textContent = variant.title);
        root.querySelectorAll('[data-sp-pair]').forEach(link => link.hidden = link.dataset.spPair !== variant.options[0]);
        document.title = variant.title + ' | Sherbinskis';
        if (changeUrl) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
      }

      if (variant?.image) {
        const selectedIndex = allPhotos.findIndex(photo => photo.dataset.mediaId === String(variant.image));
        if (selectedIndex >= 0) {
          gallery.prepend(allPhotos[selectedIndex]);
          rail.prepend(allThumbs[selectedIndex]);
          allPhotos = [...gallery.children];
          allThumbs = [...rail.querySelectorAll('[data-sp-thumbnail]')];
        }
      }
      const color = choices[0];
      const hasColorPhotos = allPhotos.some(photo => photo.dataset.photoColor?.trim() === color);
      allPhotos.forEach((photo, index) => {
        const photoColor = photo.dataset.photoColor?.trim();
        const visible = !hasColorPhotos || !photoColor || photoColor === color;
        photo.hidden = !visible;
        allThumbs[index].hidden = !visible;
      });
      photos = allPhotos.filter(photo => !photo.hidden);
      photos.forEach(photo => photo.querySelectorAll('img').forEach(img => img.alt = variant?.title || img.alt));
      thumbs = allThumbs.filter(thumb => !thumb.hidden);
      thumbs.forEach((thumb,index) => thumb.setAttribute('aria-label', root.dataset.photoLabel.replace('[number]', index+1).replace('[title]', variant?.title || '')));
      photoIndex = 0;
      showPhoto(0);
    }

    root.querySelectorAll('[data-sp-option] input').forEach(input => input.addEventListener('change', () => updateVariant(true, input.closest('[data-sp-option]'))));
    updateVariant(false);
  });
}
initializeSherbProducts(document);
document.addEventListener('shopify:section:load', event => initializeSherbProducts(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sherb-range-card"] && !Shopify.designMode) return;
  try {
    function refreshSherbDraftLinks(){
  const element=document.getElementById('OnlineStorePreviewBarNextData');
  if(!element)return;
  try{
    const context=JSON.parse(element.textContent);
    if(context.theme?.id!==197554569382||!context.theme.isDraft)return;
    const token=context.theme.sharingAccessToken,shopId=context.shop?.id;
    if(!/^[a-z0-9]+$/.test(token)||!/^\d+$/.test(String(shopId)))return;
    document.querySelectorAll('[data-sherb-draft-link]').forEach(link=>{const url=new URL(link.href);url.protocol='https:';url.hostname=token+'-'+shopId+'.shopifypreview.com';url.searchParams.delete('preview_theme_id');link.href=url.toString();});
  }catch{}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refreshSherbDraftLinks);else refreshSherbDraftLinks();
document.addEventListener('shopify:section:load',refreshSherbDraftLinks);
  } catch(e) { console.error(e); }
})();

})();
